import { IApplicationState } from '../../types/redux';

export function selectResultsOffersCount(state: IApplicationState) {
  return state.results.offersCount;
}
